export enum GshopProductFieldType {
  Title = "title",
  Description = "description",
  Brand = "brand",
  GoogleProductCategory = "google_product_category",
  ProductType = "product_type",
  Link = "link",
  CustomLabel0 = "custom_label_0",
  CustomLabel1 = "custom_label_1",
  CustomLabel2 = "custom_label_2",
  CustomLabel3 = "custom_label_3",
  CustomLabel4 = "custom_label_4",
}
